<template>
  <div>
    <List
      @toDetail="GoDetails"
      @GoSorter="GoSorter"
      :activeKey="activeKey"
      :dataList="dataList"
      :nameTouristComponent="nameTouristComponent"
      :activeNum="activeNum"
      :dishTypeOpts="dishTypeOpts" />
    <template v-if="false">
      <ul class="ul" v-for="v in touristList" :key="v.id" @click="GoDetails(v.id, v)">
        <li class="firstname" :style="{ 'background-color': color16() }" v-if="v.lesseeName">
          {{ v.lesseeName.charAt(0) }}
        </li>
        <li class="content-li">
          <div class="name li-item 55">
            <div class="name-top">
              <div style="margin-right: 4px">
                <p class="black lesseeName">{{ v.lesseeName }}</p>
              </div>
              <a-tag class="label" color="pink" v-if="v.identityFive === 'Y'"> 五 </a-tag>
              <a-tag class="label" color="green" v-if="v.identityExcellent === 'Y'"> 优 </a-tag>
              <a-tag class="label" color="orange" v-if="v.identityWill === 'Y'"> 意向 </a-tag>
            </div>
            <p class="words">
              {{ v.requirementAreaStart ? v.requirementAreaStart + '平方米左右' : '暂无参考面积' }}
            </p>
          </div>
          <div class="address li-item">
            <p class="black">{{ v.brandName ? v.brandName : '暂无品牌数据' }}</p>
            <p
              class="con-overflow"
              :title="v.businessDistrictName ? v.businessDistrictName + v.streetName : '暂无地址信息'"
            >
              {{ v.businessDistrictName ? v.businessDistrictName + v.streetName : '暂无地址信息' }}
            </p>
          </div>
          <div class="price li-item">
            <p
              class="con-overflow red"
              :title="(v.requirementAreaStart || 0) + '-' + (v.requirementAreaEnd || 0) + 'm²'"
            >
              <span>{{ v.requirementAreaStart || 0 }} </span>- <span>{{ v.requirementAreaEnd || 0 }} </span> m²
            </p>
            <p class="con-overflow" :title="(v.rentExpenseStart || 0) + '-' + (v.rentExpenseEnd || 0) + '元/月'">
              {{ v.rentExpenseStart ? v.rentExpenseStart : 0 }}-{{ v.rentExpenseEnd ? v.rentExpenseEnd : 0 }}元/月
            </p>
          </div>
          <div class="desc li-item">
            <p
              class="black con-overflow"
              v-if="v.followUpCreateTime"
              :title="$moment(v.followUpCreateTime).format('YY-MM-DD HH:mm') + ' 跟进'"
            >
              {{ $moment(v.followUpCreateTime).format('YY-MM-DD HH:mm') + ' 跟进' }}
            </p>
            <p class="black con-overflow" v-else>暂无跟进</p>
            <p class="con-overflow" :title="v.takeLookCount + '次带看，' + v.inMoreCount + '次一带多看'">
              {{ v.takeLookCount }} 次带看，{{ v.inMoreCount }} 次一带多看
            </p>
          </div>
          <div class="agent li-item">
            <p class="black con-overflow" :title="((v && v.teamName) || '*') + '-' + v.relatedPersonnelName">
              {{ (v && v.teamName) || '*' }}-{{ v.relatedPersonnelName }}
              <!--{{
              v.relatedPersonnelName && v.relatedPersonnelName.length > 7
                ? v.relatedPersonnelName.substr(0, 7) + '...'
                : v.relatedPersonnelName
            }}-->
            </p>
            <p class="con-overflow" :title="$moment(v.relatedPersonnelCreateTime).format('YY-MM-DD HH:mm') + ' 录入'">
              {{ $moment(v.relatedPersonnelCreateTime).format('YY-MM-DD HH:mm') + ' 录入' }}
            </p>
          </div>
          <div v-for="d in dishTypeOpts" :key="d.dictValue">
            <div
              class="type li-item"
              :class="{
                type1: d.dictLabel == '私盘',
                type2: d.dictLabel == '单店',
                type3: d.dictLabel == '公司',
              }"
              v-if="d.dictValue == v.dishType"
            >
              {{ d.dictLabel }}
            </div>
          </div>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import List from '../../list/modules/list.vue'
export default {
  components: {
    List
  },
  props: {
    dataList: {
      type: Array,
      default: () => [],
      require: true
    },
    nameTouristComponent: {
      type: String,
      default: ''
    },
    dishTypeOpts: {
      type: Array,
      default: () => [],
      require: true
    },
    activeKey: {
      type: [String, Number],
      default: ''
    },
    activeNum: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      touristList: []
    }
  },
  watch: {
    dataList: {
      handler (val) {
        console.log('rent dataList==', val)
        this.touristList = val
      },
      deep: true,
      immediate: true
    },
    nameTouristComponent: {
      handler (val) {},
      immediate: true
    },
    // 监听
    activeNum: {
      handler (val) {},
      immediate: true
    }
  },
  methods: {
    // 点击跳转客源列表详情页
    GoDetails (id, item) {
      console.log(item, this.activeNum, 'item数据')
      sessionStorage.setItem('toDetail', JSON.stringify({ fromPage: 'toDetails' }))
      this.$router.push({
        path: '/tourist/details',
        query: {
          id: id,
          activeNum: this.activeNum,
          storeId: item.storeId,
          teamId: item.teamId,
          userStatus: item.userStatus,
          canTabs: true
          // fromPage:'list'
        }
      })
    },
    // 到主页重新请求数据
    GoSorter (requirementSort, sortType) {
      this.$emit('GoSorter', requirementSort, sortType)
    },
    // 十六进制颜色随机
    color16 () {
      var r = Math.floor(Math.random() * 256)
      var g = Math.floor(Math.random() * 256)
      var b = Math.floor(Math.random() * 256)
      var color = '#' + r.toString(16) + g.toString(16) + b.toString(16)
      return color
    }
  }
}
</script>

<style lang="less" scoped>
.con-overflow {
  width: 98%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ul {
  &:hover {
    background: #f0f5ff;
  }
  cursor: pointer;
  display: flex;
  height: 120px;
  align-items: center;
  list-style: none;
  padding-left: 0;
  margin-left: 10px;
  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }
  .black {
    color: #000;
    font-weight: 700;
  }
  .lesseeName {
    min-width: 44px;
  }
  .firstname {
    font-size: 30px;
    width: 70px;
    height: 70px;
    background-color: var(--ThemeColor);
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    margin-right: 30px;
  }

  .content-li {
    flex: 1;
    display: flex;
    height: 120px;
    border-bottom: 1px solid #ccc;
    width: calc(100% - 100px);
    .li-item {
      width: 17%;
    }
    .name {
      display: flex;
      flex-direction: column;
      padding: 26px 0;
      justify-content: space-between;
      margin-right: 25px;
      .name-top {
        display: flex;
        .label {
          height: 20px;
        }
      }
      .words {
        width: 300px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .address {
      padding: 30px 0;
    }
    .price {
      padding: 30px 0;
      .red {
        color: red;
        font-weight: 700;
      }
    }
    .desc {
      padding: 30px 0;
    }
    .agent {
      padding: 30px 0;
    }
    .type {
      margin-top: 40px;
      color: white;
      width: 50px;
      height: 30px;
      line-height: 30px;
      border-radius: 16px;
      text-align: center;
    }
    .type1 {
      background-color: #389e0d;
    }
    .type2 {
      background-color: #d48806;
    }
    .type3 {
      background-color: #cf1322;
    }
  }
}
</style>
